// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', {log1p: require('./_math-log1p')});


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/es6.math.log1p.js
// module id = 120
// module chunks = 0